import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    card: {
        padding: theme.spacing(1),
    },
    prod: {
        fontWeight: 'bold',
    }
}))